import React, { useState, useRef } from 'react';
import { Image, Text, Box } from 'rebass';
import Wrapper from './Wrapper';
import { label } from 'babys-first-year/Step3';
import { postMemberIdentifiers, updateIdentifier, updateMember } from 'members/api';
import { formatMemberBody } from 'members/helper';

import Banner from 'app/payment/Banner';
import * as Yup from 'yup';
import { TextInput } from 'app/payment/DesignGiftCertificate';
import SweetKoala from './assets/SweetKoala.png';
import useEntities from 'entities/hooks/use-entities';

const schema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email address')  // Built-in email validation
        .required('Email is required'),   // Make the email field required
});

const AddEmail = ({
    onStepUp,
    onStepDown,
    quantity,
    setRequiresQuantity,
    calculatedPricing,
    generateInvoice,
    orderSummary,
    firePostMemberEvent,
    member,
    email,
    setEmail,
    isForMyBaby,
    hideSkip,
    ...props
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState({})
    const [status, setStatus] = useState({ type: '', message: '' });
    const ref = useRef(null);
    const memberId = member?.id;

    const allIdentifiers = useEntities('identifiers');
    const validIdentifierId = Object.keys(allIdentifiers).find(id => allIdentifiers[id].type === "UsernamePassword")

    const onSubmit = async () => {
        if (email && !error?.email) {
            setIsSubmitting(true)
            if (isForMyBaby && props?.redeemCode && status.type === 'success') {
                onStepUp(9)
            }
            else {
                if (props.setRedeemCode)
                    props.setRedeemCode(null)
                const res = await generateInvoice()
                if (res) {
                    onStepUp()
                    window.scrollBy({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            }
            setIsSubmitting(false)
        } else {
            ref.current.scrollIntoView({ block: 'center' });
            setError({ email: 'Email is required' });
        }

    }

    return (<Wrapper
        hideSkip={hideSkip}
        onSubmit={onSubmit}
        onBack={onStepDown}
        isSubmitting={isSubmitting}
    >
        <Box width="100vw" >
            <Box m="auto" mt="4.7%" mb="40px" width={['92%', '92%', '33%']} minWidth={['max-width', 480]}>
                <Box mt="30px">
                    <Text
                        color="codGrey"
                        textAlign="left"
                        fontFamily="Bitter"
                        fontSize={"30px"}
                        lineHeight="120%"
                        letterSpacing="-0.18px"
                        fontWeight={400}
                    >
                        {member?.['has-username-password-identifier'] ? 'Update Your Account Email Address?' : 'Get Started'}
                    </Text>
                    {/* <NotReadyYetModal firePostMemberEvent={firePostMemberEvent} isFromGiftGiver={isFromGiftGiver} /> */}
                </Box>

                {member?.['has-username-password-identifier'] && <Text
                    my="30px"
                    color="#64748B"
                    fontSize={16}
                    fontFamily="Poppins"
                    lineHeight="150%"
                    letterSpacing="-0.32px"
                    textAlign="left"
                >
                    We will send your receipt to this email and also update your account login.
                </Text>}


                <TextInput
                    ref={ref}
                    title={label(<Text as="span" fontFamily="Poppins" fontSize={15} letterSpacing="-0.3px">
                        Email
                    </Text>, true)
                    }
                    subText="Check your spam if not received."
                    placeholder="Enter your email"
                    defaultValue={email}
                    error={error?.email}
                    // onChange={(e) => e.target.value ? schema
                    //     .validate({ email: e.target.value })
                    //     .then(async () => {
                    //         setError({});
                    //         setEmail(e.target.value)
                    //     }) : null}
                    onBlur={(e) => {
                        schema
                            .validate({ email: e.target.value })
                            .then(async () => {
                                setError({});
                                setEmail(e.target.value)
                                if (member?.email !== e.target.value) {
                                    if (validIdentifierId) {
                                        const body = formatMemberBody(validIdentifierId, { email: e.target.value });
                                        await updateIdentifier(validIdentifierId, body, '/identifiers')
                                    } else {
                                        const body = formatMemberBody(memberId, { email: e.target.value });
                                        await postMemberIdentifiers(memberId, body, '/identifiers')
                                    }
                                }
                            })
                            .catch((err) => {
                                setError({ ...error, email: err.errors });
                            });
                    }}
                />
                {(props?.redeemCode && props?.status?.message) && (
                    <Banner
                        bg={(props?.status.type === 'success') ? 'successBg' : 'pinks.1'}
                        color={(props?.status.type === 'success') ? 'success' : 'pinks.5'}
                        heading={props?.status.message || "Gift card applied successfully"}
                        text={props?.status.subTitle || "You're all set to preserve and celebrate your little one's firsts"}
                        p="16px"
                        size={'small'}
                        mb={2}
                    />
                )}
                {!member?.['has-username-password-identifier'] && <Text
                    color="codGrey"
                    fontSize={16}
                    fontFamily="Poppins"
                    lineHeight="150%"
                    fontWeight={400}
                    letterSpacing="-0.096px"
                    textAlign="left"
                    mt="40px"
                    mb={5}
                >
                    We’ll also send helpful tips and updates from time to time. You can unsubscribe anytime.
                </Text>}
                <Image src={SweetKoala} m="auto" display="block" />
            </Box>
        </Box>
    </Wrapper>
    );
};

export default AddEmail;
